import { actions as rootActions, tableViewType } from '../../../list';

const createStatusesFilter = ({
	namespace,
	stateNodeName
}) => {
	const CHOOSE_FILTER = `${namespace}/${stateNodeName}-choose-filter`;

	// initState
	const initialState = {
		filters: [
			{ name: 'opened', placeholder: 'Opened', active: true},
			{ name: 'paused', placeholder: 'Paused', active: false},
			{ name: 'closed', placeholder: 'Closed', active: false}
		]
	};

	// actions
	const actions = {
		chooseStatusesFilter: filterName => dispatch => {
			dispatch({
				type: CHOOSE_FILTER,
				payload: filterName
			});

			dispatch(rootActions.apply());
		}
	};

	// reducers
	const reducers = {
		[CHOOSE_FILTER]: (state, action) => ({
			...state,
			table: {
				...state.table,
				view: action.payload === 'closed' || action.payload === 'paused' ? tableViewType.list : tableViewType.group
			},
			[stateNodeName]: {
				filters: state[stateNodeName].filters.map(entity => ({
					...entity,
					active: action.payload === entity.name
				}))
			}
		})
	};

	// selectors
	const selectors = {
		getFilters: state => state[namespace][stateNodeName].filters
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createStatusesFilter;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/quick-filters/statuses/index.js